<template lang='pug'>
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          .review(v-if='sent', color='primary', @click.prevent='')
          v-card(flat)
            breadcrumb(back='page10-4')
              | Estás en: Elige tu Crédito Hipotecario / ¿Qué aprendí en esta lección?
            v-card-text.label16tt.withDivider
              span(style='color:#F7893B ') PREGUNTA 4 DE 4
            img.pt-3(style="width:61px; heigth:67px;", src="assets/cronometro.gif")
            v-card-text.chrono
              b {{("0" + Math.floor(time / 60)).slice(-2) +":" + ("0"+(time - Math.floor(time / 60) * 60)).slice(-2)}}
            v-card-text.titulo24Reg.mx-2.px-0.pt-4.pb-0.mb-0
              | Selecciona las palabras a los espacios vacíos para que el texto refleje tu percepción de ese futuro de la mejor manera posible. 
            v-card.questionCard.mx-4(justify-center, flat)
              v-layout(row, justify-center)
                v-flex.py-2.my-3(align-content-center)
                  p.titulo18Book.text-xs-left.px-5.py-0.my-0(style='line-height: 80px;')
                    | Para obtener un Crédito Hipotecario, los requisitos básicos que debes cubrir son:
                    br
                    span(v-for="reactivo in reactivos")
                      span.px-2
                        | {{reactivo.pregunta}}
                      span
                        v-icon.pr-2(v-if='sent && (reactivo.resultado==1)' size='15px', color='green') fas fa-check
                        v-icon.pr-2(v-if='sent && (reactivo.resultado==0)' size='15px', color='red ') fas fa-times
                      span.selector
                        v-select(v-if="show" :items='reactivo.opciones' v-model='reactivo.respuesta' label='Selecciona...' solo  height='59')
            v-layout(row, justify-center)
              v-flex
                div(v-if='sent==false ')
                  v-btn.btn(color='secondary ', v-bind:class='responseIsNone ', :disabled='!completed', @click=' sendResult() ')
                    | Enviar
                div(v-if='sent ')
                  v-btn.btn(color='accent ', style='z-index:2', @click.prevent='dialog=true ')
                    | Ver Retroalimentación
                  v-dialog(v-model='dialog ', persistent, max-width='930px ')
                    v-layout(row, justify-center)
                      v-flex(text-xs-center)
                        v-card
                          div(v-if='sent && (resultado==1) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoArriba.png ')
                          div(v-if='sent && (resultado!=1) ')
                            v-layout(v-if='dialog ')
                              v-flex(text-xs-center)
                                img.dialog_img(src='assets/Leccion_1.5_ManoStop.png ')
                          v-spacer.my-1.py-4
                          div(v-if='sent && (resultado==1) ')
                            v-card-text.headline
                              | ¡Bien!
                            v-card.questionCard(justify-center, flat)
                              v-card-text.text-xs-left.px-5.parrafoRetro14B
                                b ¡Bien contestado!
                                |  Con tu aprendizaje, sabemos que la frase correcta se lee así:
                              v-card-text.text-xs-left.px-5.parrafoRetro14B
                                b Para obtener un Crédito Hipotecario, los requisitos básicos que debes cubrir son: 
                                b  presentar una 
                                b(class="accent--text")  identificación oficial vigente 
                                b  y tener entre 18 y 
                                b(class="accent--text")   64 años/11 meses, 
                                b  vivir en 
                                b(class="accent--text")   México 
                                b  y contar con un buen 
                                b(class="accent--text")   historial crediticio.
                                b  Por otro lado, la vivienda que elijas debe estar 
                                b(class="accent--text")   escriturada
                                b  , libre de gravamen 
                                b  y valuada por un 
                                b(class="accent--text")   perito autorizado. 
                          div(v-if='sent && (resultado!=1) ')
                            v-card-text.headline
                              | Hay una mejor respuesta...
                            v-card.questionCard(justify-center, flat)
                              v-card-text.text-xs-left.px-5.ParrafoRetro14B
                                b Te acercaste!
                                |  !, pero la frase correcta se lee así:
                              v-card-text.text-xs-left.px-5.parrafoRetro14B
                                b Para obtener un Crédito Hipotecario, los requisitos básicos que debes cubrir son: 
                                b  presentar una 
                                b(class="accent--text")  identificación oficial vigente 
                                b  y tener entre 18 y 
                                b(class="accent--text")   64 años/11 meses, 
                                b  vivir en 
                                b(class="accent--text")   México 
                                b  y contar con un buen 
                                b(class="accent--text")   historial crediticio.
                                b  Por otro lado, la vivienda que elijas debe estar 
                                b(class="accent--text")   escriturada
                                b  , libre de gravamen 
                                b  y valuada por un 
                                b(class="accent--text")   perito autorizado.
                          v-btn.btn.dialog_btn(color='accent ', @click.prevent="nextPage( 'page10-6')")
                            | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>

<script>
import {
  eventBus
} from '../main';

function shuffle(a) {
  var j, x, i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
}
export default {
  name: 'app',
  deactivated() {
    this.time = 135;
    this.timer = null;
  },
  activated() {
    if (!this.timer) {
      this.timer = setInterval(() => {
        if ((this.time > 0) && !this.sent) {
          this.time--
        } else {
          clearInterval(this.timer);
          if (!this.sent) {
            this.sendResult();
            this.nextPage('p05');
          }
        }
      }, 1000)
    }
  },
  data() {
    return {
      dialog: false,
      resultado: 0,
      response: 'none',
      sent: false,
      show: false,
      correcta: false,
      completo: 'none',
      time: 135,
      timer: null,
      interaction : {
        id : "TCH.L2.p10-4",
        questionText : "Completa la frase",
        learnerResponse: "",
        correctAnswer : "",
        wasCorrect : true
      },
      reactivos: [{
          pregunta: 'Presentar una',
          correctas: [
            'identificación oficial vigente'
          ],
          opciones: [
            'identificación oficial vigente',
            'carta de recomendación'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'y tener entre 18 y',
          correctas: [
            '64 años/11 meses'
          ],
          opciones: [
            '64 años/11 meses',
            '66 años'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: ', vivir en',
          correctas: [
            'México'
          ],
          opciones: [
            'México',
            'cualquier país'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'y contar con un buen',
          correctas: [
            'historial crediticio'
          ],
          opciones: [
            'historial crediticio',
            'ingreso'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: '. Por otro lado, la vivienda que elijas debe estar',
          correctas: [
            'escriturada'
          ],
          opciones: [
            'escriturada',
            'pendiente de escriturar'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        },
        {
          pregunta: 'libre de gravamen y valuada por un',
          correctas: [
            'perito autorizado'
          ],
          opciones: [
            'perito autorizado',
            'abogado'
          ],
          respuesta: '',
          respuestaUnica: '',
          resultado: 0
        }
      ],
      opciones: [
        "Co-financiamiento", "Crédito Bancario", "INFONAVIT", "FOVISSTE", "Sofol"
      ]
    }
  },
  methods: {
    grade: function(reactivos) {
      var points = 0;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.correctas.includes(reactivo.respuesta)) {
          reactivo.resultado = 1;
          points++;
        }
      });
      this.resultado = points / this.reactivos.length;
    },
    sendResult() {
      this.grade();
      this.sent = true;
      eventBus.$emit('send_result', this.resultado);
    },
    nextPage(page) {
      this.progress = true;
      eventBus.$emit('next_page', page);
    },
    lastPage(page) {
      this.progress = true;
      eventBus.$emit('last_page', page);
    }
  },
  beforeMount: function() {
    shuffle(this.opciones);
  },
  beforeUpdate: function() {
    var opciones = this.opciones;
    this.reactivos.forEach(function(reactivo) {
      if (reactivo.respuesta.length == 2) {
        if (reactivo.respuesta[0] == reactivo.respuestaUnica) {
          opciones.push(reactivo.respuesta.shift());
        } else {
          opciones.push(reactivo.respuesta.pop());
        }
      }
      reactivo.respuestaUnica = reactivo.respuesta[0];
    });
  },
  computed: {
    completed() {
      var complete = true;
      this.reactivos.forEach(function(reactivo) {
        if (reactivo.respuesta == "") {
          complete = false;
        }
      });
      return complete;
    },
    responseIsNone() {
      return {
        'btn-primary': this.response != 'none',
        'btn-secondary': this.response == 'none'
      }
    }
  },
  created() {
        window.setInterval(() => {
      this.show = true;
    },2000);
  }
};
</script>
